import type { NavigationItemResponse } from '@models/partner/menu/navigation-item';
import type { Observable } from 'rxjs';

import { inject } from '@angular/core';
import { NavigationItemService } from '@features/partners/builder/settings/menu/navigation-item/navigation-item.service';

export const navigationItemResolver = (): Observable<NavigationItemResponse> =>
  inject(NavigationItemService).navigationItem$;
